<template>
    <div>
        <div class="text-right ml-auto mb-4" style="position: sticky; top: 0px; z-index: 99; width: fit-content">
            <button class="btn btn-common-cancel mr-3" @click="handleCancel">{{ $t('btn.cancel') }}</button>
            <button class="btn btn-common btn-success" @click="handleSave">{{ $t('btn.save') }}</button>
        </div>
        <div class="form-group row">
            <label class="col-sm-2 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingHeadBlock.contentFirstView') }} </label>
            <div class="col-sm-8">
                <Editor
                    :id="`ActioncontentFirstView`"
                    :model.sync="cinitForm.html_content_first_view"
                    :modelEvents="`change keydown blur focus paste`"
                    :configInit="configEditor"
                    @init="onEditorInit"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Editor from '@/components/Editor/main.vue';

export default {
    name: 'ActionHeadBlock',
    components: {
        Editor
    },
    props: {
        objHead: {
            type: Object,
            default: () => {}
        }
    },

    computed: {},
    data() {
        return {
            cinitForm: this.initForm(),
            objEditor: null,
            configEditor: {
                height: 500,
                content_style: ''
            }
        };
    },

    methods: {
        initForm() {
            return {
                html_content_first_view: '',
                html_content_finished_view: ''
            };
        },

        handleCancel() {
            this.$emit('cancel');
        },

        onEditorInit(editor) {
            this.objEditor = editor;
        },

        handleSave() {
            this.$emit('save', this.cinitForm);
        }
    },
    watch: {
        objHead: {
            handler: function (newObj) {
                this.cinitForm = {
                    ...this.cinitForm,
                    ...newObj
                };
            },
            immediate: true
        }
    },
    mounted() {}
};
</script>

<style lang="scss" scoped></style>
